module.exports = __webpack_public_path__ + "static/img/njddBottom.cd4ff709.png";